<template>
    <transition
        :css="false"
        @enter="intro"
        @leave="outro"
    >
        <div class="ChapterIndex">
            <p class="ChapterIndex-stage">
                <span ref="index" class="ChapterIndex-index">
                    {{ paddedIndex }}
                </span>
                <span ref="total" class="ChapterIndex-total">
                    _ {{ total }}
                </span>
            </p>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'ChapterIndex',
    props: {
        index: {
            type: Number,
            required: true,
        },
        total: {
            type: Number,
            required: true,
        },
    },
    data: () => ({
        indexWidth: 0,
    }),
    methods: {
        intro(el, done) {
            const { $refs } = this
            TweenMax.set(el, {
                alpha: 1,
            })
            TweenMax.staggerFromTo([$refs.index, $refs.total], 0.75, {
                y: '100%',
            }, {
                y: '0%',
            }, 0.075, done)
        },
        outro(el, done) {
            TweenLite.to(el, 0.75, {
                alpha: 0,
                ease: Cubic.easeOut,
                onComplete: done,
            })
        },
    },
    computed: {
        paddedIndex() {
            const { index } = this
            return `${index}`.padStart(2, '0')
        },
    },
}
</script>

<style src="styles/components/ChapterIndex.styl" lang="stylus"></style>


// WEBPACK FOOTER //
// src/app/components/ChapterIndex.vue